import { render, staticRenderFns } from "./RightClickMenu.vue?vue&type=template&id=f526d738&"
import script from "./RightClickMenu.vue?vue&type=script&lang=ts&"
export * from "./RightClickMenu.vue?vue&type=script&lang=ts&"
import style0 from "./RightClickMenu.vue?vue&type=style&index=0&id=f526d738&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports